import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// web/src/components/chat/templates/QuickAnswer.tsx
// Factual single-shot lookups ("what's AAPL trading at", "what's my net
// worth"). One-line answer + optional single metric. No deep dive.
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { HeadlineMetrics } from "./HeadlineMetrics";
// See Conversational.tsx for the rationale — Tailwind preflight strips
// <ul>/<ol> styling so markdown bullets must be re-applied per component.
const MARKDOWN_COMPONENTS = {
    ul: ({ children, ...props }) => (_jsx("ul", { className: "list-disc list-outside pl-5 space-y-1 my-2", ...props, children: children })),
    ol: ({ children, ...props }) => (_jsx("ol", { className: "list-decimal list-outside pl-5 space-y-1 my-2", ...props, children: children })),
    li: ({ children, ...props }) => (_jsx("li", { className: "leading-relaxed", ...props, children: children })),
};
export function QuickAnswer({ message }) {
    const text = message.content?.trim() ?? "";
    const metrics = message.headline_metrics ?? [];
    return (_jsxs("div", { className: "space-y-2", children: [text && (_jsx("div", { className: "text-base text-slate-100 leading-relaxed", children: _jsx(ReactMarkdown, { remarkPlugins: [remarkGfm], components: MARKDOWN_COMPONENTS, children: text }) })), metrics.length > 0 && _jsx(HeadlineMetrics, { metrics: metrics.slice(0, 2) })] }));
}
